import React from "react";

const PromptsLoader = () => {
    return(
        <div className="prompts_loader_cont">
            <div className="prompts_loader_cont_list">
                <div className="prompts_loader_cont_list_item_header fade-in"></div>
                <div className="prompts_loader_cont_list_item fade-in"></div>
                <div className="prompts_loader_cont_list_item fade-in"></div>
                <div className="prompts_loader_cont_list_item fade-in"></div>
                <div className="prompts_loader_cont_list_item fade-in"></div>

            </div>
             <div className="text_btn_loader_cont">
                <div className="text_loader_cont">
                    <div className="text_loader_bottom fade-in"></div>
                    <div className="text_loader_top fade-in"></div>
                </div>
                <div className="btn_loader_cont">
                    <div className="btn_loader fade-in"></div>
                    <div className="btn_loader fade-in"></div>
                </div>
            </div>
        </div>
    )
}

export default PromptsLoader